class collectionGridItem extends HTMLElement {
  constructor() {
      super();
      this.mainCollection = document.querySelector("[js-hb-main-collection]");
      this.desktopPosition = parseInt(this.dataset.hbPositionDesk);
      this.mobilePosition = parseInt(this.dataset.hbPositionMob);
      

      this.init();

  };
  init() {
      this.appendGridItem();
  };

  appendGridItem() {
      const grid = this.mainCollection.querySelector(`[js-product-grid]`);
      if (!grid) return;
      const position = document.documentElement.clientWidth > 767 ? this.desktopPosition : this.mobilePosition;
      const items = grid.querySelectorAll('.product-grid__item');
      const targetProductItem = grid.querySelector(`.product-grid__item:nth-child(${position})`);
      if (targetProductItem) {
          targetProductItem.insertAdjacentHTML("beforebegin", this.innerHTML);
      } else if (items.length > 0) {
          grid.insertAdjacentHTML("beforeend", this.innerHTML);
      }
  };
}

customElements.define('collection-grid-item', collectionGridItem);